
import Aos from "aos";
import { useEffect } from "react";

const BankvoleBillsSection = () => {
  useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);
  return (
    <section className="bv-bills">
      <div className="bv-bills-left" data-aos="flip-left" data-aos-duration="1500">
        <img
          src={`${process.env.PUBLIC_URL}/assets/img/bankvole-bills-photo.png`}
          alt="Customer paying bills on Bankvole"
          className="bv-bills-photo"
        />

      </div>

      <div className="bv-bills-right" data-aos="fade-right" data-aos-duration="1000" data-aos-delay="200" data-aos-easing="ease-in-out">
        <span className="bv-eyebrow">AUTOMATE EVERYDAY BILLS</span>
        <h2 className="bv-bills-title">Your everyday payments, handled.</h2>
        <p className="bv-bills-text">
          Buy airtime, data bundles, electricity tokens, TV subscriptions,
          health insurance and other utilities using our one-tap
          solution—or schedule them as recurring payments.
        </p>
      </div>
    </section>
  );
};

export default BankvoleBillsSection;
